import * as yup from 'yup';
import { EMAIL_REG_EXP } from '../../../../shared/constants';
import type { Invitation } from '../InvitationsGrid/types';
import {
  ALREADY_ON_TEAM_INVITE_MESSAGE,
  isEmailAlreadyOnTeam,
} from './invitationFormUtils';
import { InviteMemberFormData } from './types';

export function buildInviteMemberSchema(
  invitations: readonly Invitation[] = [],
  ignoreInvitationId?: string,
): yup.ObjectSchema<InviteMemberFormData> {
  return yup.object({
    email: yup
      .string()
      .required('This field is required')
      .matches(EMAIL_REG_EXP, 'Invalid email format')
      .test(
        'already-on-team',
        ALREADY_ON_TEAM_INVITE_MESSAGE,
        function isAlreadyOnSelectedTeam(value) {
          const teamId = this.parent.teamId as string | undefined;
          if (!value || !teamId) {
            return true;
          }

          return !isEmailAlreadyOnTeam({
            email: value,
            teamId,
            invitations,
            ignoreInvitationId,
          });
        },
      ),
    teamId: yup.string().required('This field is required'),
    roles: yup
      .array()
      .of(yup.string().required())
      .default([])
      .min(1, 'Select at least one role'),
    applications: yup
      .array()
      .of(yup.string().required())
      .default([])
      .min(1, 'Select at least one application'),
  });
}

export const DEFAULT_INVITE_MEMBER_VALUES: InviteMemberFormData = {
  email: '',
  teamId: '',
  roles: [],
  applications: [],
};
